import { render } from "./FinalRecordViewer.vue?vue&type=template&id=2faadd2e"
import script from "./FinalRecordViewer.vue?vue&type=script&lang=js"
export * from "./FinalRecordViewer.vue?vue&type=script&lang=js"

import "./FinalRecordViewer.vue?vue&type=style&index=0&id=2faadd2e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__